// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// // Async thunk for fetching dashboard stats
// export const fetchDashboardStats = createAsyncThunk(
//   "dashboardStats/fetchDashboardStats",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await fetch(
//         "http://localhost:3000/super-admin/dashboard-stats"
//       );

//       if (!response.ok) {
//         throw new Error("Failed to fetch dashboard stats");
//       }

//       const result = await response.json();

//       if (result.success) {
//         const { data } = result;

//         // Transform API data to match card structure
//         const transformedData = [
//           {
//             title: "Total Registered Companies",
//             subtitle: "",
//             value: data.totalRegisteredCompanies.toString(),
//             growth: "",
//             growthText: "",
//             valueColor: "#8b5cf6",
//           },
//           {
//             title: "Active Companies",
//             subtitle: "",
//             value: data.activeCompanies.toString(),
//             growth: "",
//             growthText: `${data.inactiveCompanies} companies are not active`,
//             lastUpdate: "New Companies",
//             lastUpdateValue: data.newCompanies.toString(),
//             valueColor: "#8b5cf6",
//           },
//           {
//             title: "Total Recruiter",
//             subtitle: "",
//             value: data.totalRecruiters.toString(),
//             growth: "",
//             growthText: "",
//             valueColor: "#8b5cf6",
//           },
//         ];

//         return transformedData;
//       } else {
//         throw new Error(result.message || "Failed to fetch data");
//       }
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   }
// );

// const dashboardStatsSlice = createSlice({
//   name: "dashboardStats",
//   initialState: {
//     statsData: [
//       {
//         title: "Total Registered Companies",
//         subtitle: "Updated Wed, January",
//         value: "0",
//         growth: "+23%",
//         growthText: "compared to last month",
//         valueColor: "#8b5cf6",
//       },
//       {
//         title: "Active Companies",
//         subtitle: "Updated Wed, January",
//         value: "0",
//         growth: "",
//         growthText: "companies are not active",
//         lastUpdate: "Last month",
//         lastUpdateValue: "0",
//         valueColor: "#8b5cf6",
//       },
//       {
//         title: "New Companies",
//         subtitle: "Updated Wed, January",
//         value: "0",
//         growth: "+23%",
//         growthText: "registrations over the past six months",
//         valueColor: "#8b5cf6",
//       },
//     ],
//     loading: false,
//     error: null,
//   },
//   reducers: {
//     clearError: (state) => {
//       state.error = null;
//     },
//     resetDashboardStats: (state) => {
//       state.statsData = [
//         {
//           title: "Total Registered Companies",
//           subtitle: "Updated Wed, January",
//           value: "0",
//           growth: "+23%",
//           growthText: "compared to last month",
//           valueColor: "#8b5cf6",
//         },
//         {
//           title: "Active Companies",
//           subtitle: "Updated Wed, January",
//           value: "0",
//           growth: "",
//           growthText: "companies are not active",
//           lastUpdate: "Last month",
//           lastUpdateValue: "0",
//           valueColor: "#8b5cf6",
//         },
//         {
//           title: "New Companies",
//           subtitle: "Updated Wed, January",
//           value: "0",
//           growth: "+23%",
//           growthText: "registrations over the past six months",
//           valueColor: "#8b5cf6",
//         },
//       ];
//       state.loading = false;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchDashboardStats.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(fetchDashboardStats.fulfilled, (state, action) => {
//         state.loading = false;
//         state.statsData = action.payload;
//         state.error = null;
//       })
//       .addCase(fetchDashboardStats.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       });
//   },
// });

// export const { clearError, resetDashboardStats } = dashboardStatsSlice.actions;

// export default dashboardStatsSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Get API base URL from environment variables
const API_BASE_URL = process.env.REACT_APP_SUPERADMIN_APP_API_BASE_URL;

// Async thunk for fetching dashboard stats
export const fetchDashboardStats = createAsyncThunk(
  "dashboardStats/fetchDashboardStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}/super-admin/dashboard-stats`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch dashboard stats");
      }

      const result = await response.json();

      if (result.success) {
        const { data } = result;

        // Transform API data to match card structure
        const transformedData = [
          {
            title: "Total Registered Companies",
            subtitle: "",
            value: data.totalRegisteredCompanies.toString(),
            growth: "",
            growthText: "",
            valueColor: "#8b5cf6",
          },
          {
            title: "Active Companies",
            subtitle: "",
            value: data.activeCompanies.toString(),
            growth: "",
            growthText: `${data.inactiveCompanies} companies are not active`,
            lastUpdate: "New Companies",
            lastUpdateValue: data.newCompanies.toString(),
            valueColor: "#8b5cf6",
          },
          {
            title: "Total Recruiter",
            subtitle: "",
            value: data.totalRecruiters.toString(),
            growth: "",
            growthText: "",
            valueColor: "#8b5cf6",
          },
        ];

        return transformedData;
      } else {
        throw new Error(result.message || "Failed to fetch data");
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const dashboardStatsSlice = createSlice({
  name: "dashboardStats",
  initialState: {
    statsData: [
      {
        title: "Total Registered Companies",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "+23%",
        growthText: "compared to last month",
        valueColor: "#8b5cf6",
      },
      {
        title: "Active Companies",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "",
        growthText: "companies are not active",
        lastUpdate: "Last month",
        lastUpdateValue: "0",
        valueColor: "#8b5cf6",
      },
      {
        title: "New Companies",
        subtitle: "Updated Wed, January",
        value: "0",
        growth: "+23%",
        growthText: "registrations over the past six months",
        valueColor: "#8b5cf6",
      },
    ],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetDashboardStats: (state) => {
      state.statsData = [
        {
          title: "Total Registered Companies",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "+23%",
          growthText: "compared to last month",
          valueColor: "#8b5cf6",
        },
        {
          title: "Active Companies",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "",
          growthText: "companies are not active",
          lastUpdate: "Last month",
          lastUpdateValue: "0",
          valueColor: "#8b5cf6",
        },
        {
          title: "New Companies",
          subtitle: "Updated Wed, January",
          value: "0",
          growth: "+23%",
          growthText: "registrations over the past six months",
          valueColor: "#8b5cf6",
        },
      ];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.statsData = action.payload;
        state.error = null;
      })
      .addCase(fetchDashboardStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetDashboardStats } = dashboardStatsSlice.actions;

export default dashboardStatsSlice.reducer;
